import * as React from "react";

const DOMableComponentWrapper = (
  WrappedComponent: React.ComponentType<any>
) => {
  class DOMableComponent extends React.Component {
    constructor(props: any) {
      super(props);
    }

    public render() {
      const propsWithDOM = Object.assign({}, this.props, { domRef: document });

      return <WrappedComponent {...propsWithDOM} />;
    }
  }

  return DOMableComponent;
};

export default DOMableComponentWrapper;



// WEBPACK FOOTER //
// ./src/route/DOMableComponent.tsx